var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13168 3.99821C6.58883 2.5912 6.81744 1.8877 7.24123 1.8877C7.66503 1.8877 7.89363 2.5912 8.35079 3.99821L8.55088 4.61406C8.67728 5.00295 8.74046 5.19739 8.89376 5.30879C9.04712 5.4202 9.25158 5.4202 9.66049 5.4202H10.3229C11.815 5.4202 12.5612 5.4202 12.6913 5.82489C12.8215 6.2296 12.2154 6.66459 11.0031 7.53469L10.477 7.91228C10.1429 8.15209 9.97578 8.27196 9.9164 8.45297C9.85702 8.63392 9.9206 8.82951 10.0477 9.22064L10.2462 9.83156C10.7033 11.2386 10.9319 11.9421 10.589 12.1912C10.2462 12.4403 9.64772 12.0055 8.45084 11.1359L7.927 10.7553C7.59619 10.5149 7.43076 10.3948 7.24123 10.3948C7.05171 10.3948 6.88628 10.5149 6.55547 10.7553L6.03163 11.1359C4.83475 12.0055 4.23631 12.4403 3.89343 12.1912C3.55056 11.9421 3.77914 11.2386 4.23631 9.83156L4.4364 9.21568C4.56277 8.82683 4.62594 8.63235 4.56737 8.4521C4.5088 8.27185 4.3434 8.15168 4.01259 7.91135L3.48873 7.53072C2.29185 6.66115 1.69341 6.22633 1.82437 5.82328C1.95534 5.4202 2.69505 5.4202 4.17448 5.4202H4.82201C5.23091 5.4202 5.43536 5.4202 5.5887 5.30879C5.74204 5.19739 5.80521 5.00295 5.93159 4.61406L6.13168 3.99821Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic-star.1b204cbfae701bf10f5119a3ce3a8778.svg";
export { ForwardRef as ReactComponent };